import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { ServiceProjectPartPayload } from '../models/part-payload';

export const ServiceProjectPartAddActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[service/project-part] Add'),
  requestFail: uniqueActionType('[service/project-part] Add fail'),
  requestSuccess: uniqueActionType('[service/project-part] Add success'),
  requestClearErrors: uniqueActionType('[service/project-part] Add clear errors'),
  requestClear: uniqueActionType('[service/project-part] Add clear'),
};

export class ServiceProjectPartAddAction implements PayloadAction {
  readonly type = ServiceProjectPartAddActionTypes.request;

  constructor(public payload: SendByIdPayload<ServiceProjectPartPayload>) {
  }
}

export class ServiceProjectPartAddFailAction implements PayloadAction {
  readonly type = ServiceProjectPartAddActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ServiceProjectPartAddSuccessAction implements PayloadAction {
  readonly type = ServiceProjectPartAddActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class ServiceProjectPartAddClearErrorsAction implements PayloadAction {
  readonly type = ServiceProjectPartAddActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class ServiceProjectPartAddClearAction implements PayloadAction {
  readonly type = ServiceProjectPartAddActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
